export function shareRecentDebugLogs(text: string): Promise<void> {
  const url = URL.createObjectURL(new Blob([text], { type: "text/plain" }));
  try {
    const anchor = document.createElement("a");
    anchor.download = "han-recent-logs.txt";
    anchor.href = url;
    document.body.append(anchor);
    anchor.click();
    anchor.remove();
  } finally {
    URL.revokeObjectURL(url);
  }
  return Promise.resolve();
}
